import { MembersService } from "./services/members.service";

export { MembersService } from "./services/members.service";

export const SERVICES: any[] = [
	MembersService
];
